export default __webpack_public_path__ + "static/media/badge.16f8b650.svg";